import { render, staticRenderFns } from "./LaundryFormService.vue?vue&type=template&id=0b824e9c&scoped=true&"
import script from "./LaundryFormService.vue?vue&type=script&lang=js&"
export * from "./LaundryFormService.vue?vue&type=script&lang=js&"
import style0 from "./LaundryFormService.vue?vue&type=style&index=0&id=0b824e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b824e9c",
  null
  
)

export default component.exports